import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchOperatorUserActionsChargePoint: ['chargePointId', 'filter', 'offset'],
  fetchOperatorUserActionsChargePointLoading: null,
  fetchOperatorUserActionsChargePointLoadingMore: null,
  fetchOperatorUserActionsChargePointSuccess: [
    'offset',
    'chargePointActions',
    'nextOffset',
  ],
  fetchOperatorUserActionsChargePointFail: ['error'],

  resetOperatorUserActionsChargePoint: null,
  setOperatorUserActionsPaginationOffset: ['offset'],

  setOperatorUserActionsFilters: ['filters'],

  fetchOperatorUserActions: ['filter', 'offset'],
  fetchOperatorUserActionsLoading: null,
  fetchOperatorUserActionsLoadingMore: null,
  fetchOperatorUserActionsSuccess: ['offset', 'actions', 'nextOffset'],
  fetchOperatorUserActionsFail: ['error'],
  clearOperatorUserActions: null,
  clearOperatorUserActionsFilters: null,

  fetchOperatorUserActionsUser: ['userId', 'filter', 'offset'],
  fetchOperatorUserActionsUserLoading: null,
  fetchOperatorUserActionsUserLoadingMore: null,
  fetchOperatorUserActionsUserSuccess: ['offset', 'actions', 'nextOffset'],
  fetchOperatorUserActionsUserFail: ['error'],
  clearOperatorUserActionsUser: null,
  fetchOperatorUserActionsChargingToken: [
    'chargingTokenId',
    'filter',
    'offset',
  ],
  fetchOperatorUserActionsChargingTokenLoading: null,
  fetchOperatorUserActionsChargingTokenLoadMore: null,
  fetchOperatorUserActionsChargingTokenSuccess: [
    'offset',
    'chargingTokenActions',
    'nextOffset',
    'filter',
  ],
  fetchOperatorUserActionsChargingTokenFail: ['error'],
  resetOperatorUserActionsChargingToken: null,
  setOperatorUserActionsChargingTokenPaginationOffset: ['offset'],
})

export const OperatorUserActionsTypes = Types
export default Creators
